
import { Vue, Component, Mixins, Emit, Watch } from "vue-property-decorator";
import store from "@/store";
import CommonHeaderJa from "@/components/common/CommonHeaderJa.vue";
import CommonHeaderEn from "@/components/common/CommonHeaderEn.vue";
import CommonFooterJa from "@/components/common/CommonFooterJa.vue";
import CommonFooterEn from "@/components/common/CommonFooterEn.vue";

@Component({
  components: {
    CommonHeaderJa,
    CommonFooterJa,
    CommonHeaderEn,
    CommonFooterEn,
  },
})
export default class LoginLayout extends Vue {
  private name = "LoginLayout";
  get lang(): string {
    return store.getters["auth/lang"];
  }
  get isShow(): boolean {
    return store.getters.loaded;
  }
  get caption(): string {
    if (this.lang === "en") {
      return "Mitsui Garden Hotel Jigugaien Tokyo Premier";
    }
    return "三井ガーデンホテル神宮外苑の社プレミア";
  }
}
